<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<ng-container>
  <div class="container">
    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 leyenda1">
          <p>Listado de Entidades de Certificación y Evaluación</p>
        </div>
      </div>
    </div>
    <br />
    <div class="panel panel-danger">
      <div class="panel-heading">
        <p class="encabezado">Entidad de certificación y evaluación</p>
      </div>
      <br />

      <div class="container">
        <h1 class="h1_tittle">Datos generales</h1>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-3">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Cédula:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.cedula ? details.cedula : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Razón Social:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.razonSocial ? details.razonSocial : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Siglas:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{ details?.siglas ? details.siglas : "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-3">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Fecha:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.fechaAcreditacion
                          ? details.fechaAcreditacion
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <h1 class="h1_tittle">Dirección</h1>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Calle y Número:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.calleNumero &&
                        details?.calleNumero !== "" &&
                        details?.calleNumero !== " "
                          ? details.calleNumero
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Colonia:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.colonia &&
                        details?.colonia !== "" &&
                        details?.colonia !== " "
                          ? details.colonia
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Delegación / Municipio:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.municipio &&
                        details?.municipio !== "" &&
                        details?.municipio !== " "
                          ? details.municipio
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Entidad Federativa:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.entidadFederativa &&
                        details?.entidadFederativa !== "" &&
                        details?.entidadFederativa !== " "
                          ? details.entidadFederativa
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Código Postal :</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.codigoPostal &&
                        details?.codigoPostal !== "" &&
                        details?.codigoPostal !== " "
                          ? details.codigoPostal
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="container">
        <h1 class="h1_tittle">Contácto</h1>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Teléfonos:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.telefonos &&
                        details?.telefonos !== "" &&
                        details?.telefonos !== " "
                          ? details.telefonos
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">E-mail:</p>
                  </div>
                  <div class="col-sm-12">
                    <div *ngIf="emailList.length > 0; else noEmails">
                      <div *ngFor="let email of emailList">
                        <p class="letra">{{ email }}</p>
                      </div>
                    </div>
                    <ng-template #noEmails>
                      <p class="letra">N/A</p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4">
          <div class="container_div">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading1">
                  <div class="col-sm-12">
                    <p class="encabezado2">Sitio Web:</p>
                  </div>
                  <div class="col-sm-12">
                    <p class="letra">
                      {{
                        details?.sitioWeb &&
                        details?.sitioWeb !== "" &&
                        details?.sitioWeb !== " "
                          ? details.sitioWeb
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />

      <div class="row">
        <div class="container">
          <div class="col-sm-5"></div>
          <div style="text-align: center" class="col-sm-1">
            <button mat-button (click)="close()">
              <img src="./assets/images/icon/Atras.png" class="imagen" />
            </button>
          </div>
          <div style="text-align: center" class="col-sm-1">
            <button mat-button (click)="close()">
              <img src="./assets/images/icon/Home.png" class="imagen" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
